import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

export default function StartOrderDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();

    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper style={{ width: "400px" }} {...props} />
            </Draggable>
        );
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose={props.closeDialog}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >   <div className={classes.headerIcon}> <PlayArrowIcon className={classes.largePlayIcon}></PlayArrowIcon>
            </div>
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <DialogContentText className={classes.dialogContext}>
                {props.dialogContext}
            </DialogContentText>
            <div className={classes.dialogTable}>
                <div className={classes.row}>
                    <div className={classes.nameCell}>
                        {"Line"}
                    </div>
                    <div className={classes.valueCell}>
                        {props.productionOrder.machinePlannedCode}
                    </div>
                </div>
                {!props.preparation? <div className={classes.row}>
                    <div className={classes.nameCell}>
                        {"Pieces to produce"}
                    </div>
                    <div className={classes.valueCell}>
                        {props.productionOrder.bomOut[0].quantityToProduce}
                    </div>
                </div>
                    :
                    <React.Fragment></React.Fragment>}
                <div className={classes.row}>
                    <div className={classes.nameCell}>
                        {"Boxes to fill"}
                    </div>
                    <div className={classes.valueCell}>
                        {props.preparation? props.productionOrder.bomOut[0].quantityToProduce : Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier)}
                    </div>
                </div> </div>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.startButton} autoFocus onClick={() => props.startOrder()} >
                        <PlayArrowIcon className={classes.playIcon}></PlayArrowIcon>{"START"}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "620px !important",
        margin: "auto"
    },
    buttons: {
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        width: "235px",
    },
    startButton: {
        color: "white",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        backgroundColor: "#5CC958",
        '&:hover': {
            backgroundColor: "#5CC958",
        },
        margin: "3px",
        width: "130px",
        marginTop: "20px",
        marginBottom: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px",
        paddingBottom: "0px",
        cursor: 'move',
    },
    dialogContext: {
        color: "#000000",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "10px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    },
    row: {
        width: "100%",
        height: "25px"
    },
    valueCell: {
        width: "40%",
        textAlign: "right",
        float: "left",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'regular',
    },
    nameCell: {
        width: "60%",
        textAlign: "left",
        float: "left",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    dialogTable: {
        height: "80px",
        width: "100%",
        paddingLeft: "80px",
        paddingRight: "80px",
        boxSizing: "border-box"
    },
    playIcon: {
        width: "35px",
        height: "35px",
        color: "white",
    },
    largePlayIcon: {
        width: "100px",
        height: "100px",
        color: "gray",
        position: "relative",
        bottom: "25px"
    }

}));
